import type { JsonQuestionOption } from './types';

function normalizeNoneText(text: string): string {
  return text
    .toLowerCase()
    .replace(/[_/\\-]+/g, ' ')
    .replace(/[^a-z0-9\s]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

export function isNoneLikeValue(value: string): boolean {
  const text = normalizeNoneText(value);
  if (!text) return false;
  if (text === 'none' || text === 'no' || text === 'na' || text === 'n a') return true;
  if (text.startsWith('none ') || text.startsWith('no known ')) return true;
  if (text.includes('none of the above') || text.includes('none of these')) return true;
  const parts = text.split(' ').filter(Boolean);
  return (
    (parts.includes('none') || parts.includes('na') || text.includes('n a')) &&
    (text.includes('not applicable') || text.includes('n a'))
  );
}

export function isNoneOption(option: JsonQuestionOption): boolean {
  const normalized = normalizeNoneText(`${option.label} ${option.value}`);
  const label = normalizeNoneText(option.label);
  const value = normalizeNoneText(option.value);

  return (
    isNoneLikeValue(label) ||
    isNoneLikeValue(value) ||
    normalized.includes('none of the above') ||
    normalized.includes('none of these')
  );
}
